var exports = {
  "kL": "x31de4314--5af34b--container",
  "iE": "x31de4314--5af34b--wrapper",
  "az": "x31de4314--5af34b--with-banner",
  "s_": "x31de4314--5af34b--with-margin",
  "DD": "x31de4314--5af34b--title",
  "Dk": "x31de4314--5af34b--carousel",
  "K5": "x31de4314--5af34b--carousel--skeleton",
};

module.exports = exports;
